module.exports = __webpack_public_path__ + "img/uy.fb1289c8.svg";